import FloraActions from "./actions";

const INITIAL_STATE = {
  data: null,
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form: {},
  isNewRecord: false,
  showModal: false,
  onSubmit: false,
  list: [],
  dataFlora: null,
  errorInternal: false,
};

function FloraReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FloraActions.NEW_DATA:
      return {
        ...state,
        errorInternal: false,
        errorMessage: [],
        onSubmit: false,
        isProcessing: false,
        single: null,
        form: INITIAL_STATE.form,
        isNewRecord: true,
        showModal: true,
      };
    case FloraActions.UPDATE_DATA:
      return {
        ...state,
        errorInternal: false,
        errorMessage: [],
        onSubmit: false,
        isProcessing: false,
        single: null,
        isNewRecord: false,
      };
    case FloraActions.VIEW_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        dataFlora: action.payload,
        isNewRecord: false,
        showModal: true,
      };
    case FloraActions.RESET_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        form: INITIAL_STATE.form,
        showModal: false,
      };
    case FloraActions.DELETE_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        form: INITIAL_STATE.form,
        showModal: false,
      };
    case FloraActions.ON_SUBMIT:
      return { ...state, errorInternal: false, onSubmit: true };
    case FloraActions.SHOW_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isError: false,
        list: action.payload,
        errorMessage: [],
        isProcessing: false,
      };
    case FloraActions.ERROR_DATA:
      return {
        ...state,
        errorInternal: false,
        isError: true,
        onSubmit: false,
        errorMessage: action.payload,
        isProcessing: false,
        dataFlora:null
      };
    case FloraActions.SUCCESS_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isError: false,
        showModal: false,
        form: INITIAL_STATE.form,
        onSubmit: false,
      };
    case FloraActions.PROCESS_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: true,
        isError: false,
        isSuccess: false,
        dataFlora:null,
      };
    //  case FloraActions.GET_HELPER_COA2:
    //    return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperCoa2:action.payload};
    case FloraActions.ERROR_SERVER:
      return {
        ...state,
        isError: false,
        errorInternal: true,
        onSubmit: false,
        errorMessage: action.payload,
        isProcessing: false,
      };

    default:
      return state;
  }
}

export default FloraReducer;
